/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SaveResponseRequest = {
    /**
     * Index of the question (0-based)
     */
    question_index: number;
    /**
     * Category of the question
     */
    question_category?: SaveResponseRequest.question_category | null;
    /**
     * Title of the question
     */
    question_title: string;
    /**
     * Full text of the question
     */
    question_text: string;
    /**
     * User's answer to the question
     */
    answer?: string | null;
    /**
     * Type of questionnaire (defaults to superpower for backward compatibility)
     */
    questionnaire_type?: SaveResponseRequest.questionnaire_type | null;
};
export namespace SaveResponseRequest {
    /**
     * Category of the question
     */
    export enum question_category {
        EXPERTISE = 'expertise',
        NICHES = 'niches',
        IDEAL_REQUEST = 'ideal_request',
        FEAR = 'fear',
        DESIRE = 'desire',
        MECHANISM = 'mechanism',
        TRANSFORMATION = 'transformation',
        CLIENT_GREEN = 'client_green',
        CLIENT_RED = 'client_red',
        HISTORY = 'history',
        VALUES = 'values',
        PERSONA = 'persona',
        NICHE = 'niche',
        IDEAS = 'ideas',
        EMOTIONS = 'emotions',
        STRENGTHS = 'strengths',
        GROWTH = 'growth',
        INTERESTS = 'interests',
        CONTEXT = 'context',
        FACTS = 'facts',
        INSPIRATION = 'inspiration',
        ATTITUDE = 'attitude',
        PAST = 'past',
        PRESENT_FUTURE = 'present_future',
        PERSONALITY_VALUES = 'personality_values',
        AUTHORSHIP = 'authorship',
        COMMUNICATION = 'communication',
        MARKET = 'market',
    }
    /**
     * Type of questionnaire (defaults to superpower for backward compatibility)
     */
    export enum questionnaire_type {
        SUPERPOWER = 'superpower',
        PERSONALITY = 'personality',
        EXPERTISE = 'expertise',
    }
}

